import { TextDataResponseDTO } from '../../../../services/interfaces/apiInterfaces'
import { LabelGrids } from '../../../../containers/models/labelGrids';


export class LabelAddClient extends LabelGrids {
  titleAddClient: TextDataResponseDTO;
  completeProfile: TextDataResponseDTO;
  fieldsRequired: TextDataResponseDTO;
  deleteClient: TextDataResponseDTO;
  newClient: TextDataResponseDTO;
  dropDownClient: TextDataResponseDTO;
  dropDownFare: TextDataResponseDTO;
  dropDownFareSearch: TextDataResponseDTO;
  dropDownClientSerach: TextDataResponseDTO;
  clientSelectType: TextDataResponseDTO;
  clientSelectPassenger: TextDataResponseDTO;
  clientSelectBusiness: TextDataResponseDTO;
  btnCancel: string;
  newPayment: string;
  firstName: TextDataResponseDTO;
  email: TextDataResponseDTO;
  phone: TextDataResponseDTO;
  lastName: TextDataResponseDTO;
  addresses: TextDataResponseDTO[];
}
